import React from "react";
import { useGetPageQuery, useSendFormMutation } from "../../redux/services/crmAPI";
import { Link, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { succsesDataChangeAlert } from "../../alerts/alerts";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { useSelector } from "react-redux";

const CurrentClient = () => {
    const navigate = useNavigate();

    const permissions = useSelector((state) => state.status.permissions);

    const { id } = useParams();

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [address, setAddress] = useState("");
    const [card, setCard] = useState("");
    const [discount, setDiscount] = useState(0);

    const { data: client, refetch: refetchClient } = useGetPageQuery("clients/" + id);
    const [sendForm, { isLoading, isError }] = useSendFormMutation();

    const sendFormHandler = async () => {
        const formData = {
            name: name,
            email: email,
            phone: phone,
            address: address,
            card: card,
            discount: discount,
        };

        await sendForm({ body: formData, url: "clients/" + id, method: "PUT" }).unwrap();
        await refetchClient();

        if (!isError) {
            succsesDataChangeAlert();
            // navigate("/clients");
        }
    };

    useEffect(() => {
        if (client) {
            setName(client.name);
            setEmail(client.email);
            setPhone(client.phone);
            setAddress(client.address);
            setCard(client.card);
            setDiscount(client.discount);
        }
    }, [client]);

    const calculateTotalPriceWithDiscount = (order) => {
        const totalOrderPrice = order.products.reduce((price, product) => {
            return (price += product.prices.price * product.prices.quantity);
        }, 0);
        const discount = order.discount;
        const priceWithDiscount = totalOrderPrice - (discount / 100) * totalOrderPrice;
        return priceWithDiscount;
    };

    const calculateTotalOrderPrice = (client) => {
        return client.orders.reduce((totalPrice, order) => {
            return (totalPrice += calculateTotalPriceWithDiscount(order));
        }, 0);
    };

    return (
        <>
            {client && (
                <div className="content">
                    <div className="col-12">
                        <div id="page-header">
                            <h1>{client.name}</h1>
                        </div>
                        <div className="form client_form">
                            <input
                                type="hidden"
                                name="id"
                            />
                            <div className="row">
                                <div className="col-12 col-sm-6 col-lg-6">
                                    <div className="card card-default">
                                        <div className="card-header">Інформація покупця</div>
                                        <div className="card-body">
                                            <div className="mb-2">
                                                <label className="form-label">Ім'я</label>
                                                <input
                                                    className="form-control"
                                                    maxLength="255"
                                                    type="text"
                                                    value={name}
                                                    onChange={(e) => setName(e.target.value)}
                                                />
                                            </div>
                                            <div className="mb-2">
                                                <label className="form-label">Телефон</label>
                                                <input
                                                    className="form-control"
                                                    maxLength="255"
                                                    type="text"
                                                    value={phone}
                                                    onChange={(e) => setPhone(e.target.value)}
                                                />
                                            </div>
                                            <div className="mb-2">
                                                <label className="form-label">Email</label>
                                                <input
                                                    className="form-control"
                                                    maxLength="255"
                                                    type="text"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                />
                                            </div>
                                            <div className="mb-2">
                                                <label className="form-label">Адреса</label>
                                                <input
                                                    className="form-control"
                                                    maxLength="255"
                                                    type="text"
                                                    value={address}
                                                    onChange={(e) => setAddress(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {permissions.includes("client_edit") || permissions.includes("all") ? (
                                        <div className="saves_block">
                                            <button
                                                name="user_info"
                                                className="btn btn-primary"
                                                onClick={sendFormHandler}
                                            >
                                                {isLoading ? "Завантаження" : "Зберегти"}
                                            </button>
                                        </div>
                                    ) : null}
                                </div>

                                <div className="col-12 col-sm-6 col-lg-6">
                                    <div className="card card-default">
                                        <div className="card-header">Дисконтна карта клієнта</div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-12 col-sm-6">
                                                    <div className="mb-2">
                                                        <label className="form-label">Номер карти</label>
                                                        <input
                                                            type="text"
                                                            name="card"
                                                            className="form-control"
                                                            value={card}
                                                            onChange={(e) => setCard(e.target.value)}
                                                        />
                                                    </div>
                                                    <div className="mb-2">
                                                        <label className="form-label">Знижка</label>
                                                        <div className="input-group">
                                                            <input
                                                                type="text"
                                                                name="discount"
                                                                className="form-control"
                                                                value={discount}
                                                                onChange={(e) => setDiscount(e.target.value)}
                                                            />
                                                            <span
                                                                className="input-group-text"
                                                                id="discount"
                                                            >
                                                                %
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-sm-6">
                                                    <svg id="barcode_card"></svg>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="card card-default">
                                        <div className="card-header">Замовлення клієнта</div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-12">
                                                    {client.orders.length < 1 ? (
                                                        <div className="alert alert-info">
                                                            У клієнта немає замовлень
                                                        </div>
                                                    ) : (
                                                        <table className="table table-striped">
                                                            <thead>
                                                                <tr>
                                                                    <th data-field="id">ID</th>
                                                                    <th
                                                                        data-field="user_name"
                                                                        className="no-mobile"
                                                                    >
                                                                        Товари
                                                                    </th>
                                                                    <th
                                                                        data-field="user_total"
                                                                        className="no-mobile"
                                                                    >
                                                                        Сума
                                                                    </th>
                                                                    <th
                                                                        data-field="user_date"
                                                                        className="no-mobile"
                                                                    >
                                                                        Дата
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {client?.orders
                                                                    ? client.orders.map((order) => {
                                                                          return (
                                                                              <tr key={order.id}>
                                                                                  <td>
                                                                                      <Link
                                                                                          to={"/order/" + order.id}
                                                                                          data-id="179398"
                                                                                          className="mobile-select"
                                                                                      >
                                                                                          Замовлення&nbsp;#{order.id}
                                                                                      </Link>
                                                                                      <div className="note note-note">
                                                                                          Примітка: {order.note}
                                                                                      </div>
                                                                                      <ul className="list_purchaches on-mobile">
                                                                                          {order.products.map(
                                                                                              (product) => {
                                                                                                  return (
                                                                                                      <li
                                                                                                          key={
                                                                                                              product.id
                                                                                                          }
                                                                                                      >
                                                                                                          <Link
                                                                                                              to={
                                                                                                                  "/product/" +
                                                                                                                  product.id
                                                                                                              }
                                                                                                          >
                                                                                                              {
                                                                                                                  product.title
                                                                                                              }
                                                                                                          </Link>
                                                                                                      </li>
                                                                                                  );
                                                                                              }
                                                                                          )}
                                                                                          <li>Ремонт</li>
                                                                                      </ul>
                                                                                  </td>
                                                                                  <td className="no-mobile">
                                                                                      <ul className="list_purchaches ">
                                                                                          {order.products.map(
                                                                                              (product) => {
                                                                                                  return (
                                                                                                      <li>
                                                                                                          <Link
                                                                                                              to={
                                                                                                                  "/product/" +
                                                                                                                  product.id
                                                                                                              }
                                                                                                          >
                                                                                                              {
                                                                                                                  product.title
                                                                                                              }
                                                                                                          </Link>
                                                                                                      </li>
                                                                                                  );
                                                                                              }
                                                                                          )}
                                                                                      </ul>
                                                                                  </td>
                                                                                  <td className="no-mobile">
                                                                                      {calculateTotalOrderPrice(client)}
                                                                                      &nbsp;грн
                                                                                  </td>
                                                                                  <td className="no-mobile">
                                                                                      05.04.2023
                                                                                  </td>
                                                                              </tr>
                                                                          );
                                                                      })
                                                                    : null}
                                                            </tbody>
                                                        </table>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="card card-default">
                                        <div className="card-header">Ремонти клієнта</div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-12">
                                                    {client.repairs.length < 1 ? (
                                                        <div className="alert alert-info">У клієнта немає ремонтів</div>
                                                    ) : (
                                                        <table className="table table-striped">
                                                            <thead>
                                                                <tr>
                                                                    <th data-field="id">ID</th>
                                                                    <th data-field="user_name">Клієнт</th>
                                                                    <th
                                                                        data-field="user_name"
                                                                        className="no-mobile"
                                                                    >
                                                                        Пристрій
                                                                    </th>
                                                                    <th
                                                                        data-field="user_date"
                                                                        className="no-mobile"
                                                                    >
                                                                        Створено
                                                                    </th>
                                                                    <th
                                                                        data-field="user_address"
                                                                        className="no-mobile"
                                                                    >
                                                                        Ціна
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {client.repairs.map((repair) => {
                                                                    return (
                                                                        <tr key={repair.id}>
                                                                            <td>
                                                                                <Link
                                                                                    to={"/repair/" + repair.id}
                                                                                    data-id="31790"
                                                                                >
                                                                                    Ремонт&nbsp;#{repair.id}
                                                                                </Link>
                                                                                <div className="fs-6 fw-light">
                                                                                    <span class="badge bg-info text-dark">
                                                                                        <i class="bi bi-unlock-fill"></i>
                                                                                        {repair.pincode}
                                                                                    </span>
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                {client.name}
                                                                                <br />
                                                                                {client.phone}
                                                                                <div
                                                                                    class="on-mobile"
                                                                                    style={{ whiteSpace: "normal" }}
                                                                                >
                                                                                    {repair.device}
                                                                                    <div class="note note-status">
                                                                                        {repair.note_master}
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td class="no-mobile">
                                                                                {repair.device}
                                                                                <div class="note note-status">
                                                                                    {repair.note_master}
                                                                                </div>
                                                                            </td>
                                                                            <td class="no-mobile">
                                                                                {moment(repair.created_at).format(
                                                                                    "DD.MM.YYYY HH:MM"
                                                                                )}
                                                                            </td>
                                                                            <td class="no-mobile">
                                                                                {repair.price}&nbsp;грн
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="card card-default">
                                        <div className="card-header">Відправлення клієнта</div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="alert alert-info">У клієнта немає відправлень</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default CurrentClient;
